import React from 'react';
const stats = [{
  value: '6 + 5',
  label: 'Volumi e bonus operativi'
}, {
  value: '23',
  label: 'Schede di lavoro codificate, WS-01 → WS-23'
}, {
  value: '10 sedute · 3 fasi',
  label: 'Fondamenta · Slancio · Integrazione'
}, {
  value: 'Legge 4/2013',
  label: 'Scritto sul quadro professionale italiano'
}];
export function SocialProofBar() {
  return <section aria-label="Cosa contiene il sistema" className="w-full bg-sage text-white" data-id="element-210" data-mp="25qrb661j2u4l">
      <div className="max-w-5xl mx-auto px-5 sm:px-8 py-7" data-id="element-211" data-mp="32ibki7ul67th">
        <ul className="grid grid-cols-2 md:grid-cols-4 divide-y md:divide-y-0 md:divide-x divide-white/15" data-id="element-212" data-mp="2xl33ial6c9tt">
          {stats.map(stat => <li key={stat.label} className="flex flex-col items-center justify-center text-center py-4 md:py-1 px-3" data-id="element-213" data-mp="2tkj5z5wov475">
              <span className="font-serif font-bold text-xl sm:text-2xl leading-tight" data-id="element-214" data-mp="1i4axknuksynk">
                {stat.value}
              </span>
              <span className="mt-2 text-[11px] sm:text-xs uppercase tracking-[0.12em] text-white/75 leading-snug" data-id="element-215" data-mp="1d69isf46nlhw">
                {stat.label}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}